import React, { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Preloader from './ui/Preloader';
import ScrollToTop from './ui/ScrollToTop';

import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import { TabProvider } from './context/TabContext';

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const delay = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(delay);
  }, []);

  return (
    <div>
      <TabProvider>
      {loading ? (
        <Preloader />
      ) : (
        <>
          <Navbar />
          <ScrollToTop />
          <div className="w-full overflow-x-hidden font-roboto">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/services" element={<Services />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <Footer />
        </>
      )}
      </TabProvider>
    </div>
  );
};

export default App;
